import React from 'react'
import BaseStore from './baseStore'
import { observable } from 'mobx'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'hljd'
import { isSiDaMember } from '@util'

class Store extends BaseStore {
  @observable
  settingParams = {
    scheduleShow: 1,
    customerDirection: 0,
    incomeDirection: 0
  }

  configOptions = [
    isSiDaMember() ? this.SCHEDULE_SHOW : null,
    {
      title: (
        <div>
          <span style={{ marginRight: 5 }}>客资管理（私信、预约、电话)</span>
          <Tooltip
            title={
              <span>
                选择「由团队管理客资」后，将产生以下影响：<br />
                ·成员将无法查看到新的客资信息<br />
                ·成员的私信、预约、电话将统一转接至团队<br />
                ·团队成员设置的智能客服、轻松聊将失效
              </span>
            }
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </div>
      ),
      name: 'customerDirection',
      disabled: isSiDaMember(),
      options: [
        {
          value: 0,
          title: '由团队管理客资'
        },
        {
          value: 1,
          title: '由成员管理客资'
        }
      ]
    },
    {
      title: (
        <div>
          <span style={{ marginRight: 5 }}>收入管理</span>
          <Tooltip
            title={
              <span>
                选择「收入归属团队」后，线上订单的资金将进入团队账户，由团队统一调拨
              </span>
            }
          >
            <QuestionCircleOutlined />
          </Tooltip>
        </div>
      ),
      name: 'incomeDirection',
      disabled: isSiDaMember(),
      options: [
        {
          value: 0,
          title: '收入归属团队'
        },
        {
          value: 1,
          title: '收入归属成员'
        }
      ]
    }
  ].filter(Boolean)
}

export default Store
